module.exports = __webpack_public_path__ + "img/girl_def2.2dc83bda.png";